document.addEventListener('DOMContentLoaded', () => {
  const openButtons = document.querySelectorAll('[data-open-product-drawer]');
  const sizeDrawer = document.querySelector('[data-product-set-drawer]');

  if (!sizeDrawer) return;

  const closeButtons = sizeDrawer.querySelectorAll('[data-close-product-drawer]');
  const imageEl = sizeDrawer.querySelector('[data-drawer-image]');
  const titleEl = sizeDrawer.querySelector('[data-drawer-title]');
  const lockedColorEl = sizeDrawer.querySelector('[data-drawer-locked-color]');
  const priceEl = sizeDrawer.querySelector('[data-drawer-price]');
  const optionsWrap = sizeDrawer.querySelector('[data-drawer-options]');
  const form = sizeDrawer.querySelector('[data-drawer-form]');
  const variantIdInput = sizeDrawer.querySelector('[data-drawer-variant-id]');
  const messageEl = sizeDrawer.querySelector('[data-drawer-message]');
  const submitButton = sizeDrawer.querySelector('[data-drawer-submit], .product-set-drawer__submit');
  const thumbsWrap = sizeDrawer.querySelector('[data-drawer-thumbs]');

  if (!imageEl || !titleEl || !priceEl || !optionsWrap || !form || !variantIdInput || !submitButton) {
    return;
  }

  let currentProduct = null;
  let currentLockedColor = null;
  let selectedOptionValues = {};

  const CART_DRAWER_SECTION_ID = 'cart-drawer';
  const CART_DRAWER_SELECTOR = '#CartDrawer';

  function formatMoney(cents) {
    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney === 'function' &&
      window.theme &&
      window.theme.moneyFormat
    ) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }

    return (Number(cents) / 100).toFixed(2);
  }

  function setMessage(text, isError = false) {
    if (!messageEl) return;

    messageEl.textContent = text || '';
    messageEl.classList.toggle('is-error', isError);
    messageEl.classList.toggle('is-success', !!text && !isError);
  }

  function openSizeDrawer() {
    sizeDrawer.classList.add('is-open');
    document.body.classList.add('product-set-drawer-open');
  }

  function closeSizeDrawer() {
    sizeDrawer.classList.remove('is-open');
    document.body.classList.remove('product-set-drawer-open');
    setMessage('');
  }

  function getColorOptionIndex(product) {
    if (!product || !Array.isArray(product.options)) return -1;

    const colorNames = ['color', 'colour', 'цвят', 'farbe'];
    return product.options.findIndex((optionName) =>
      colorNames.includes(String(optionName).trim().toLowerCase())
    );
  }

  function normalizeValue(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getInitialVariant(product, lockedColor) {
    if (!product || !Array.isArray(product.variants) || !product.variants.length) {
      return null;
    }

    const colorOptionIndex = getColorOptionIndex(product);

    if (lockedColor && colorOptionIndex !== -1) {
      const normalizedLockedColor = normalizeValue(lockedColor);

      const matchingAvailableVariant = product.variants.find((variant) => {
        return (
          normalizeValue(variant.options[colorOptionIndex]) === normalizedLockedColor &&
          variant.available
        );
      });

      if (matchingAvailableVariant) return matchingAvailableVariant;

      const matchingVariant = product.variants.find((variant) => {
        return normalizeValue(variant.options[colorOptionIndex]) === normalizedLockedColor;
      });

      if (matchingVariant) return matchingVariant;
    }

    return product.selected_or_first_available_variant || product.variants[0] || null;
  }

  function getVariantImageUrl(variant, product) {
    if (variant && variant.featured_image) {
      if (typeof variant.featured_image === 'string') return variant.featured_image;
      if (variant.featured_image.src) return variant.featured_image.src;
      if (variant.featured_image.url) return variant.featured_image.url;
    }

    if (variant && variant.featured_media) {
      if (variant.featured_media.src) return variant.featured_media.src;
      if (variant.featured_media.url) return variant.featured_media.url;

      if (variant.featured_media.preview_image) {
        if (variant.featured_media.preview_image.src) return variant.featured_media.preview_image.src;
        if (variant.featured_media.preview_image.url) return variant.featured_media.preview_image.url;
      }
    }

    if (product && Array.isArray(product.images) && product.images.length) {
      return product.images[0];
    }

    if (product && product.featured_image) {
      return product.featured_image;
    }

    return '';
  }

  function setMainImage(src, alt = '') {
    if (!src) {
      imageEl.src = '';
      imageEl.alt = '';
      imageEl.style.display = 'none';
      return;
    }

    imageEl.src = src;
    imageEl.alt = alt;
    imageEl.style.display = '';
  }

  function highlightActiveThumb(src) {
    if (!thumbsWrap) return;

    thumbsWrap.querySelectorAll('[data-drawer-thumb]').forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.imageSrc === src);
    });
  }

  function renderThumbnails(product, initialSrc) {
    if (!thumbsWrap) return;

    thumbsWrap.innerHTML = '';

    if (!Array.isArray(product.images) || !product.images.length) {
      return;
    }

    product.images.forEach((src, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'product-set-drawer__thumb';
      button.setAttribute('data-drawer-thumb', '');
      button.dataset.imageSrc = src;
      button.setAttribute('aria-label', `Image ${index + 1}`);

      const img = document.createElement('img');
      img.src = src;
      img.alt = product.title || '';
      img.loading = 'lazy';

      button.appendChild(img);

      button.addEventListener('click', () => {
        setMainImage(src, product.title || '');
        highlightActiveThumb(src);
      });

      thumbsWrap.appendChild(button);
    });

    highlightActiveThumb(initialSrc);
  }

  function findMatchingVariant(product, selectedOptionsByIndex) {
    if (!product || !Array.isArray(product.variants)) return null;

    return product.variants.find((variant) => {
      return variant.options.every((optionValue, index) => {
        return selectedOptionsByIndex[index] === optionValue;
      });
    }) || null;
  }

  function updateVariant() {
    if (!currentProduct) return;

    const matchedVariant = findMatchingVariant(currentProduct, selectedOptionValues);
    if (!matchedVariant) return;

    variantIdInput.value = matchedVariant.id;
    priceEl.textContent = formatMoney(matchedVariant.price);

    const available = !!matchedVariant.available;
    submitButton.disabled = !available;
    submitButton.textContent = available ? 'Добави в количката' : 'Няма наличност';

    const variantImage = getVariantImageUrl(matchedVariant, currentProduct);
    if (variantImage) {
      setMainImage(variantImage, currentProduct.title || '');
      highlightActiveThumb(variantImage);
    }
  }

  function renderOptions(product, initialVariant) {
    optionsWrap.innerHTML = '';
    selectedOptionValues = {};

    if (!product || !Array.isArray(product.options) || !product.options.length || !initialVariant) {
      return;
    }

    product.options.forEach((optionName, optionIndex) => {
      const values = [
        ...new Set(
          product.variants
            .map((variant) => variant.options[optionIndex])
            .filter(Boolean)
        )
      ];

      if (!values.length) return;

      const group = document.createElement('fieldset');
      group.className = 'product-set-drawer__option-group';
      group.setAttribute('data-option-group', '');
      group.dataset.optionIndex = optionIndex;

      const legend = document.createElement('legend');
      legend.className = 'product-set-drawer__option-label';
      legend.textContent = optionName;
      group.appendChild(legend);

      const valuesWrap = document.createElement('div');
      valuesWrap.className = 'product-set-drawer__option-values';

      const initialValue = initialVariant.options[optionIndex];
      selectedOptionValues[optionIndex] = initialValue;

      values.forEach((value, valueIndex) => {
        const id = `DrawerOption-${product.id}-${optionIndex}-${valueIndex}`;

        const label = document.createElement('label');
        label.className = 'product-set-drawer__option-value';
        label.setAttribute('for', id);

        const input = document.createElement('input');
        input.type = 'radio';
        input.name = `option-${optionIndex}`;
        input.value = value;
        input.id = id;
        input.checked = value === initialValue;

        input.addEventListener('change', () => {
          selectedOptionValues[optionIndex] = value;
          updateVariant();
        });

        const text = document.createElement('span');
        text.textContent = value;

        label.appendChild(input);
        label.appendChild(text);
        valuesWrap.appendChild(label);
      });

      group.appendChild(valuesWrap);
      optionsWrap.appendChild(group);
    });
  }

  function fillDrawer(product, lockedColor) {
    const initialVariant = getInitialVariant(product, lockedColor);

    currentProduct = product;
    currentLockedColor = lockedColor || null;
    selectedOptionValues = {};

    titleEl.textContent = product.title;

    if (lockedColorEl) {
      lockedColorEl.textContent = currentLockedColor ? `Цвят: ${currentLockedColor}` : '';
    }

    if (initialVariant) {
      priceEl.textContent = formatMoney(initialVariant.price);
      variantIdInput.value = initialVariant.id;
    } else {
      priceEl.textContent = '';
      variantIdInput.value = '';
    }

    const initialImage = getVariantImageUrl(initialVariant, product);
    setMainImage(initialImage, product.title || '');
    renderThumbnails(product, initialImage);
    renderOptions(product, initialVariant);
    updateVariant();
    setMessage('');
  }

  async function getCart() {
    const response = await fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) {
      throw new Error('Could not fetch cart.');
    }

    return response.json();
  }

  function updateCartCount(count) {
    const selectors = [
      '.cart-count-bubble',
      '.cart-count-bubble span',
      '[data-cart-count]',
      '.header__cart-count',
      '.cart-count',
      '.header__icon--cart .badge',
      '.icon-cart__count'
    ];

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        el.textContent = count;

        if (count > 0) {
          el.classList.remove('hidden', 'is-empty');
          el.removeAttribute('hidden');
          el.style.display = '';
        } else {
          el.classList.add('is-empty');
        }

        const bubble = el.closest('.cart-count-bubble');
        if (bubble && count > 0) {
          bubble.classList.remove('hidden', 'is-empty');
          bubble.removeAttribute('hidden');
          bubble.style.display = '';
        }
      });
    });
  }

  async function refreshCartDrawer() {
    const response = await fetch(
      `${window.Shopify.routes.root}?sections=${encodeURIComponent(CART_DRAWER_SECTION_ID)}`,
      {
        headers: { Accept: 'application/json' }
      }
    );

    if (!response.ok) {
      throw new Error('Could not refresh cart drawer.');
    }

    const data = await response.json();
    const html = data[CART_DRAWER_SECTION_ID];

    if (!html) {
      throw new Error('No cart drawer HTML returned.');
    }

    const wrapper = document.createElement('div');
    wrapper.innerHTML = html;

    const newDrawer = wrapper.querySelector(CART_DRAWER_SELECTOR);
    const currentDrawer = document.querySelector(CART_DRAWER_SELECTOR);

    if (!newDrawer || !currentDrawer) {
      throw new Error('Cart drawer element not found.');
    }

    currentDrawer.replaceWith(newDrawer);

    if (window.customElements && typeof window.customElements.upgrade === 'function') {
      window.customElements.upgrade(newDrawer);
    }

    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { open: false }
      })
    );
  }

  async function addItemToCart(variantId) {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }]
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.description || 'Неуспешно добавяне в количката.');
    }

    return response.json();
  }

  openButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const card = button.closest('[data-product-card]');
      const jsonEl = card ? card.querySelector('[data-product-json]') : null;
      const lockedColorElInCard = card ? card.querySelector('[data-locked-color-json]') : null;

      if (!jsonEl) return;

      try {
        const product = JSON.parse(jsonEl.textContent);
        const lockedColor = lockedColorElInCard
          ? JSON.parse(lockedColorElInCard.textContent)
          : null;

        fillDrawer(product, lockedColor);
        openSizeDrawer();
      } catch (error) {
        console.error('Invalid product data', error);
      }
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeSizeDrawer);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && sizeDrawer.classList.contains('is-open')) {
      closeSizeDrawer();
    }
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const variantId = Number(variantIdInput.value);
    if (!variantId) {
      setMessage('Моля, изберете вариант.', true);
      return;
    }

    submitButton.disabled = true;
    setMessage('Добавяне...');

    try {
      await addItemToCart(variantId);

      const cart = await getCart();

      updateCartCount(cart.item_count);
      closeSizeDrawer();
      await refreshCartDrawer();

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart }
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { open: false }
        })
      );
    } catch (error) {
      console.error(error);
      setMessage(error.message || 'Възникна грешка.', true);
    } finally {
      submitButton.disabled = false;
    }
  });
});